import styled from "styled-components";

export const CardList = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

export const Card = styled.div`
  width: 250px;
  display: flex;
  flex-direction: column;
  padding: 0.5rem;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  margin: 0.6rem;
  border-radius: 10px;
  background-color: ${({ theme }) => theme.backgroundSidebar};
`;

export const Img = styled.img`
  width: 100%;
  object-fit: cover;
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 1rem 0.5rem;
`;

export const Row = styled.div`
  display: flex;
  align-items: flex-end;
  margin: 1rem 1.5rem;
  /* .input-control {
    width: 100%;
  } */
`;
